import { createRoute } from '@tanstack/react-router'

import { createValidateSearch } from '@campai/lib-web/routes'

import { rootRoute } from '@/product/feedback/root'
import { SearchSchema } from '@/product/feedback/home/routeUtils'

import { Ticket } from './Ticket'

export const ticketRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/tickets/$ticketNumber',
    component: Ticket,
    validateSearch: createValidateSearch(SearchSchema),
})
